// extracted by mini-css-extract-plugin
export default {"previewContainer":"styles-module__previewContainer__src-labstep-web-screens-EntityStateWorkflow-Show-Center-_mbZ9r"};